import { getCookie } from 'cookies-next';
import mixpanel from 'mixpanel-browser';

export class Mixpanel {
  constructor(id: string) {
    const isSuperUser = Boolean(getCookie('access_super_token'));
    const isLocalHost = Boolean(process.env.APP_ENV === 'local');

    this.init(id);

    if (isSuperUser || isLocalHost) {
      mixpanel.disable();
    }
    this.isSuperUser = isSuperUser;
  }

  /** mix panel init */
  init(id: string) {
    mixpanel.init(id, {
      debug: Boolean(process.env.APP_ENV !== 'prod'),
    });
  }

  /** super props register하는 메소드 */
  register(options: object) {
    mixpanel.register_once({
      ...options,
    });
  }

  /** user identify */
  identify(userId: string) {
    mixpanel.identify(userId);
  }

  get_property(property: string) {
    return mixpanel.get_property(property);
  }

  /** event track */
  track(eventName: string, properties?: any) {
    if (!mixpanel.get_distinct_id()) {
      return;
    }

    mixpanel.track(eventName, {
      ...this.commonProperties,
      ...properties,
    });
  }

  /** user set */
  setPeople(options: object) {
    mixpanel.people.set({
      ...options,
    });
  }

  /** 정보 reset */
  reset() {
    mixpanel.reset();
  }

  setCommonProperties(properties: object) {
    this.commonProperties = properties;
  }

  private isSuperUser: boolean;
  private commonProperties: object = {};
}

let mixpanelInstance: Mixpanel | null = null;

export function initMixpanelInstance(id: string) {
  if (typeof window === 'undefined') return; // SSR 환경에서는 초기화하지 않음
  if (!mixpanelInstance) {
    mixpanelInstance = new Mixpanel(id);
  }
}

export function getMixpanelInstance(): Mixpanel | null {
  return mixpanelInstance;
}

export function mixpanelRegister(options: object) {
  const instance = getMixpanelInstance();
  if (!instance) return;
  return instance.register(options);
}

export function mixpanelIdentify(userId: string) {
  const instance = getMixpanelInstance();
  if (!instance) return;
  return instance.identify(userId);
}

export function mixpanelGetProperty(property: string) {
  const instance = getMixpanelInstance();
  if (!instance) return;
  return instance.get_property(property);
}

export function mixpanelTrack(eventName: string, properties?: any) {
  const instance = getMixpanelInstance();
  if (!instance) return;
  return instance.track(eventName, properties);
}

export function mixpanelSetPeople(options: object) {
  const instance = getMixpanelInstance();
  if (!instance) return;
  return instance.setPeople(options);
}

export function mixpanelReset() {
  const instance = getMixpanelInstance();
  if (!instance) return;
  return instance.reset();
}

export function mixpanelSetCommonProperties(properties: object) {
  const instance = getMixpanelInstance();
  if (!instance) return;
  return instance.setCommonProperties(properties);
}
